/**
 * Table pagination component overrides.
 * Clean pagination bar with subtle top border.
 */

import type { Theme } from '@mui/material/styles';

const tablePagination: Theme['components'] = {
  MuiTablePagination: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderTop: '1px solid var(--mui-palette-divider)',
        padding: theme.spacing(2, 0),
        '& .MuiTablePagination-toolbar': {
          minHeight: 52,
        },
      }),
      select: {
        borderRadius: 'var(--mui-shape-customBorderRadius-sm)',
        fontSize: '0.8125rem',
      },
      displayedRows: {
        color: 'var(--mui-palette-text-secondary)',
        fontSize: '0.8125rem',
      },
      selectLabel: {
        color: 'var(--mui-palette-text-secondary)',
        fontSize: '0.8125rem',
      },
      actions: ({ theme }) => ({
        display: 'flex',
        gap: theme.spacing(1),
        '& .MuiIconButton-root': {
          borderRadius: 'var(--mui-shape-customBorderRadius-sm)',
        },
      }),
    },
  },
};

export default tablePagination;
